/**
 * 前端 Store
 * @author jasonelchen
 */
import { composeContainer } from '@library'
import { useSession } from './session'
import { useGlobal } from './global'

// 新的 Zustand Store
export { globalStore } from './global-store'
export { sessionStore } from './session-store'
export { t3cStore } from './t3c-store'
export { notificationStore } from './notification-store'

export const { Provider, containers } = composeContainer({
  useSession,
  useGlobal,
})

export default containers
